import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, FacebookIcon, MapPinIcon, PhoneIcon, MailIcon, DoorOpenIcon } from 'lucide-react';
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-90">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.71a8.21 8.21 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.14z" data-id="element-91" />
    </svg>;
}
export function Footer() {
  return <footer className="relative bg-jet pt-20 pb-10 border-t border-gray-200 overflow-hidden" data-id="element-92">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-93">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-94">
          {/* Brand Col */}
          <div className="space-y-6" data-id="element-95">
            <div className="flex flex-col leading-tight" data-id="element-96">
              <span className="font-script text-3xl font-bold text-white tracking-wide" data-id="element-97">
                Beni's
              </span>
              <span className="text-xs uppercase tracking-[0.25em] text-white/60 font-medium" data-id="element-98">
                African Braiding
              </span>
            </div>
            <p className="text-white/70 leading-relaxed" data-id="element-99">
              Premium African hair braiding salon dedicated to protective
              styling, healthy hair, and cultural artistry.
            </p>
            <div className="flex gap-4" data-id="element-100">
              <a href="https://www.tiktok.com/@benisbraids" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-golden hover:text-jet transition-colors" data-id="element-101">
                <TikTokIcon className="w-5 h-5" data-id="element-102" />
              </a>
              <a href="https://www.instagram.com/benishairbraiding/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-golden hover:text-jet transition-colors" data-id="element-103">
                <InstagramIcon className="w-5 h-5" data-id="element-104" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-golden hover:text-jet transition-colors" data-id="element-105">
                <FacebookIcon className="w-5 h-5" data-id="element-106" />
              </a>
            </div>
            <div className="space-y-2 text-sm text-white/60" data-id="element-107">
              <a href="https://www.tiktok.com/@benisbraids" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-golden transition-colors" data-id="element-108">
                <TikTokIcon className="w-4 h-4" data-id="element-109" />
                <span data-id="element-110">@benisbraids</span>
              </a>
              <a href="https://www.instagram.com/benishairbraiding/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-golden transition-colors" data-id="element-111">
                <InstagramIcon className="w-4 h-4" data-id="element-112" />
                <span data-id="element-113">@benishairbraiding</span>
              </a>
            </div>
          </div>

          {/* Contact Col */}
          <div data-id="element-114">
            <h4 className="font-heading text-xl font-bold text-white mb-6" data-id="element-115">
              Contact Us
            </h4>
            <ul className="space-y-4 text-white/70" data-id="element-116">
              <li className="flex items-start gap-3" data-id="element-117">
                <MapPinIcon className="w-5 h-5 text-golden shrink-0 mt-1" data-id="element-118" />
                <span data-id="element-119">
                  2768 Crain Hwy
                  <br data-id="element-120" />
                  Waldorf, MD 20601
                  <br data-id="element-121" />
                  <span className="text-sm text-white/50" data-id="element-122">
                    (Beside Heritage Church International)
                  </span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-123">
                <PhoneIcon className="w-5 h-5 text-golden shrink-0 mt-1" data-id="element-124" />
                <div className="flex flex-col" data-id="element-125">
                  <span data-id="element-126">301-710-6221</span>
                  <span data-id="element-127">301-385-8034</span>
                </div>
              </li>
              <li className="flex items-center gap-3" data-id="element-128">
                <MailIcon className="w-5 h-5 text-golden shrink-0" data-id="element-129" />
                <span data-id="element-130">hello@crownglory.com</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-131">
                <DoorOpenIcon className="w-5 h-5 text-golden shrink-0" data-id="element-132" />
                <span className="text-golden font-medium" data-id="element-133">
                  Walk-ins Welcome
                </span>
              </li>
            </ul>
          </div>

          {/* Hours Col */}
          <div data-id="element-134">
            <h4 className="font-heading text-xl font-bold text-white mb-6" data-id="element-135">
              Hours
            </h4>
            <ul className="space-y-3 text-white/70" data-id="element-136">
              <li className="flex justify-between border-b border-white/10 pb-2" data-id="element-137">
                <span data-id="element-138">Tuesday - Friday</span>
                <span className="text-golden" data-id="element-139">9am - 7pm</span>
              </li>
              <li className="flex justify-between border-b border-white/10 pb-2" data-id="element-140">
                <span data-id="element-141">Saturday</span>
                <span className="text-golden" data-id="element-142">8am - 6pm</span>
              </li>
              <li className="flex justify-between border-b border-white/10 pb-2" data-id="element-143">
                <span data-id="element-144">Sunday</span>
                <span className="text-golden" data-id="element-145">10am - 4pm</span>
              </li>
              <li className="flex justify-between pb-2" data-id="element-146">
                <span data-id="element-147">Monday</span>
                <span className="text-white/40 font-bold" data-id="element-148">Closed</span>
              </li>
            </ul>
          </div>

          {/* Links Col */}
          <div data-id="element-149">
            <h4 className="font-heading text-xl font-bold text-white mb-6" data-id="element-150">
              Quick Links
            </h4>
            <ul className="space-y-3 text-white/70" data-id="element-151">
              <li data-id="element-152">
                <Link to="/services" className="hover:text-golden transition-colors" data-id="element-153">
                  Our Services
                </Link>
              </li>
              <li data-id="element-154">
                <Link to="/about" className="hover:text-golden transition-colors" data-id="element-155">
                  About the Salon
                </Link>
              </li>
              <li data-id="element-156">
                <Link to="/gallery" className="hover:text-golden transition-colors" data-id="element-157">
                  Style Gallery
                </Link>
              </li>
              <li data-id="element-158">
                <Link to="/booking" className="hover:text-golden transition-colors" data-id="element-159">
                  Book Appointment
                </Link>
              </li>
              <li data-id="element-160">
                <a href="#" className="hover:text-golden transition-colors" data-id="element-161">
                  FAQ
                </a>
              </li>
              <li data-id="element-162">
                <a href="#" className="hover:text-golden transition-colors" data-id="element-163">
                  Policies
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50" data-id="element-164">
          <p data-id="element-165">
            &copy; {new Date().getFullYear()} Beni's African Hair Braiding. All
            rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-166">
            <a href="#" className="hover:text-golden transition-colors" data-id="element-167">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-golden transition-colors" data-id="element-168">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}